import { RootLayout } from './RootLayout';

import {
  Navigate,
  RouteObject,
  createBrowserRouter
} from 'react-router-dom';


// ROUTES
import { routes as companyRoutes } from './company';
import { CompanyLayout } from './company/CompanyLayout';
import { root as organizationRoot } from './organization';

import * as admin from './admin';
import * as auth from './auth';
import * as customize from './customize';
import * as debug from './debug';
import * as insights from './insights';
import * as macroEconomics from './macroEconomics';
import * as theme from './theme';



export const routes: RouteObject[] = [
  {
    path: '',
    element: (
      <RootLayout />
    ),
    errorElement: <div>Error!</div>,
    children: [
      {
        path: '',
        element: <Navigate to='insights' />
      },
      debug.root,
      insights.root,
      {
        path: 'company',
        element: (
          <CompanyLayout />
        ),
        children: [...companyRoutes]
      },

      organizationRoot,
      {
        path: '*',
        element: (
          <div>Not Found!</div>
        )
      },
      macroEconomics.root,
      customize.root
    ]
  },

  admin.root,
  auth.root,



  theme.root
];


export const router = createBrowserRouter(routes);


